// extracted by mini-css-extract-plugin
module.exports = {"member":"menuItem_member__lP2cX","focus-visible":"menuItem_focus-visible__7l86B"};